module.exports = __webpack_public_path__ + "img/insta12.d476778c.jpg";